import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { IWorkDetails } from '../enftreport/workdetail';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class orientationPeriodService {
    private _enftreportUrl = CONFIGURATION.baseServiceUrl + 'orientationperiod/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    private data: any;
    constructor(private _http: Http) {

    }

    getReportData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._enftreportUrl + 'referencedata', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getYears() { return this.data.WorkYear; }

    getMonths() { return this.data.WorkMonth; }

    getControlGroups() { return this.data.ControlGroup; }

    getTypeOfHours() { return this.data.UnionType; }

    getNonFullTimeCategories() { return this.data.EmployeeType; }

    getWeeklyCounts(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'countByWeek?WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&UnionType=' + filterCriteria.selectedTypeOfHours
            + '&AvgWeeklyThreshold=' + filterCriteria.avgWeeklyThreshold;
        return this._http.get(this._enftreportUrl + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getWeekReportData(filterCriteria: any): Observable<IWorkDetails[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'reportdata?WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&UnionType=' + filterCriteria.selectedTypeOfHours
            + '&AvgWeeklyThreshold=' + `${filterCriteria.avgWeeklyThreshold}`
            + '&ReportOfWeek=' + filterCriteria.reportCount;
        return this._http.get(this._enftreportUrl + fileName, { headers: headers })
            .map((response: Response) => <IWorkDetails[]>response.json().reportCountByWeek)
            .catch(this.handleError);
    }

    getSSnData(ssnData: any): Observable<IWorkDetails[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'OrientationPeriodReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    downloadPDFReport(filterCriteria: any): any {
        let fileName = 'pdf-download?WorkMonth=' + filterCriteria.selectedHireMonth
        + '&ControlGroup=' + filterCriteria.selectedControlGroup
        + '&UnionType=' + filterCriteria.selectedTypeOfHours
        + '&AvgWeeklyThreshold=' + filterCriteria.avgWeeklyThreshold
        + '&ReportOfWeek=' + filterCriteria.reportCount;

        //window.open(this._enftreportUrl + fileName, '_bank');
        const url = this._enftreportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    downloadExcelReport(filterCriteria: any): any {
        let fileName = 'excel-download?WorkMonth=' + filterCriteria.selectedHireMonth
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '&UnionType=' + filterCriteria.selectedTypeOfHours
            + '&AvgWeeklyThreshold=' + filterCriteria.avgWeeklyThreshold
            + '&ReportOfWeek=' + filterCriteria.reportCount;

        //window.open(this._enftreportUrl + fileName, '_bank');
        const url = this._enftreportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/orientationperiod/orientationperiod.service.ts